import en from "./en";
import ja from "./ja";
import zhHans from "./zh-Hans";
import zhHant from "./zh-Hant";
export const locales = {
  en,
  ja,
  zhHans,
  zhHant
};